import React from "react";
import { getStyleJSON } from "Utils/Common";

export default function newFunction({ data: adminpage }) {
  if (!adminpage.usersdata) {
    return null;
  }
  return (
    <table
      align="center"
      style={getStyleJSON("width: 300px")}
      cellSpacing="0"
      cellPadding="0"
    >
      <tbody>
        {Object.keys(adminpage.usersdata).map((key) => {
          const value = adminpage.usersdata[key];
          const credits = value.credits;
          const registertime = value.registertime;
          const emails = value.emails;
          return (
            <tr key={key}>
              <td style={getStyleJSON("border: 1px solid")}>{key}</td>
              <td
                style={getStyleJSON(
                  "border: 1px solid;font-size: 10px;padding: 5px;min-width:50px"
                )}
              >
                {credits}
              </td>
              <td
                style={getStyleJSON(
                  "border: 1px solid;font-size: 10px;padding: 5px;min-width:120px"
                )}
              >
                {new Date(registertime).toLocaleString()}
              </td>
              <td
                style={getStyleJSON(
                  "border: 1px solid; font-size: 10px;min-width:300px;padding-left:2px"
                )}
              >
                {Object.keys(emails).map((key2) => {
                  const {
                    alias,
                    servers,
                    duration,
                    refillstampmillis,
                  } = value.emails[key2];

                  const currentMillis = new Date().getTime();
                  const endTime =
                    parseInt(refillstampmillis) + parseInt(duration) * 1000;
                  let active = false;
                  if (endTime > currentMillis) {
                    active = true;
                  }

                  let durationDisplay = "Inactive";
                  if (active) {
                    durationDisplay =
                      parseInt((endTime - currentMillis) / 1000 / 3600 / 24) +
                      " days";
                  }

                  if (key2.length === 0) {
                    return <div />;
                  }

                  return (
                    <>
                      <div key={key2} style={{}}>
                        <span
                          style={{ paddingLeft: "10px" }}
                        >{`${key2} (${alias})`}</span>
                        <span style={{ paddingLeft: "10px" }}>{`[${servers.join(
                          ", "
                        )}]`}</span>
                        <span style={{ paddingLeft: "10px" }}>
                          {durationDisplay}
                        </span>
                      </div>
                    </>
                  );
                })}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
